import { Order } from "components/Common/Table/SortableTableHead";
import { MouseEvent, useCallback, useState } from "react";

export const useHandleTableSort = <T extends string>(defaultOrderBy: T, defaultOrder: Order) => {
	const [orderBy, setOrderBy] = useState<T>(defaultOrderBy);
	const [order, setOrder] = useState<Order>(defaultOrder);

	const handleRequestSort = (_event: MouseEvent<unknown>, property: T) => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};

	const descendingComparator = <T>(a: T, b: T, orderBy: keyof T): number => {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	};

	const getComparator = useCallback(
		(order: Order, orderBy: T) => (a: any, b: any) =>
			order === "desc" ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy),
		[]
	);

	return { getComparator, handleRequestSort, order, orderBy };
};
